export const consts = {
    experiments: {
        fixAnonymousDefine: 'specs.thunderbolt.ComponentsRegistryFixAnonymousDefine',
        noEvalWorkaround: 'specs.thunderbolt.ComponentsRegistryNoEvalWorkaround',
    },
};
//# sourceMappingURL=consts.js.map